var render = function render(){var _vm=this,_c=_vm._self._c;return (typeof _vm.newEditor === 'boolean')?_c('div',[(_vm.newEditor)?_c('editor'):_c('resume')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }